import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteCarteiraBaixar } from '../cliente-carteira-baixar';
import { ClienteCarteiraBaixado } from '../cliente-carteira-baixado';
import { ClienteCarteiraBaixaCancelada } from '../cliente-carteira-baixa-cancelada';

@Injectable({
    providedIn: 'root'
})
export class ClienteCarteiraBaixarHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clientecarteira`;
    }

    /** Carrega os dados da baixa do do cliente baixado informado */
    loadBaixa(idCliente: number): Observable<ClienteCarteiraBaixado> {
        return this.customHttp.get<ClienteCarteiraBaixado>(`${this.pathApi}/0/baixa/${idCliente}`);
    }

    /** Realiza a baixa do cliente informado */
    baixar(entityBaixa: ClienteCarteiraBaixar): Observable<ClienteCarteiraBaixado> {
        return this.customHttp.put<ClienteCarteiraBaixado>(`${this.pathApi}/0/baixa/${entityBaixa?.idCliente}`, entityBaixa);
    }

    /** Realiza o cancelamento da baixa do cliente informado */
    cancelarBaixa(idCliente: number): Observable<ClienteCarteiraBaixaCancelada> {
        return this.customHttp.put<ClienteCarteiraBaixaCancelada>(`${this.pathApi}/0/baixa/${idCliente}/cancelar`, null);
    }
}
